import { METADATA_REQUIRED_ACTIONS } from '~/components/page/Automation/v2/components/Builder/constants/actions';
import type { ClientFlowAction } from '~/graphql/types.client';

const isMetadataRequiredAction = (action: ClientFlowAction) =>
  METADATA_REQUIRED_ACTIONS.includes(action.__typename);

export default isMetadataRequiredAction;
